/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the QuestionnaireApiConfiguration configuration object with a given root URL.
 */
export function provideQuestionnaireApiConfiguration(rootUrl: string) {
  var config = new QuestionnaireApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: QuestionnaireApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class QuestionnaireApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `QuestionnaireModule.forRoot()`
 */
export interface QuestionnaireApiConfigurationParams {
  rootUrl?: string;
}
